import type { AiErrorCode } from "../types";

/** Spanish user-facing text per typed error code (Almikia Epic EI). */
export const AI_ERROR_MESSAGES: Record<AiErrorCode, string> = {
  monthly_cap_reached: "Se alcanzó el límite mensual de IA, avisa a Dirección",
  ai_unavailable:
    "La IA no está disponible en este momento. Puedes continuar sin ella",
  invalid_response:
    "La IA devolvió una respuesta que no pudimos usar. Intenta de nuevo",
};

/** Error thrown by the data providers for a failed copilot call. */
export class AiCopilotError extends Error {
  code: AiErrorCode;
  constructor(code: AiErrorCode) {
    super(AI_ERROR_MESSAGES[code]);
    this.name = "AiCopilotError";
    this.code = code;
  }
}

/**
 * Maps any server-side `code` (the edge function also emits `ai_timeout`,
 * `budget_unavailable`, `malformed_output`, `invalid_output`) or unknown
 * failure to one of the three typed client codes. Unknown -> `ai_unavailable`.
 */
export const toAiErrorCode = (serverCode: unknown): AiErrorCode => {
  if (serverCode === "monthly_cap_reached") return "monthly_cap_reached";
  if (
    serverCode === "malformed_output" ||
    serverCode === "invalid_output" ||
    serverCode === "invalid_response"
  ) {
    return "invalid_response";
  }
  return "ai_unavailable";
};

/** Spanish message for any thrown value; never throws. */
export const aiErrorMessage = (error: unknown): string =>
  error instanceof AiCopilotError
    ? AI_ERROR_MESSAGES[error.code]
    : AI_ERROR_MESSAGES.ai_unavailable;
